import { render, staticRenderFns } from "./voiceSelect.vue?vue&type=template&id=70b3310e&scoped=true&"
import script from "./voiceSelect.vue?vue&type=script&lang=js&"
export * from "./voiceSelect.vue?vue&type=script&lang=js&"
import style0 from "./voiceSelect.vue?vue&type=style&index=0&id=70b3310e&prod&scoped=true&lang=scss&"
import style1 from "./voiceSelect.vue?vue&type=style&index=1&id=70b3310e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3310e",
  null
  
)

export default component.exports